
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"6","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#4867AA","d":"M1.5 4H0v2h1.5v6H4V6h1.821L6 4H4v-.833c0-.478.096-.667.558-.667H6V0H4.096C2.298 0 1.5.791 1.5 2.308V4z"}})])
          )
        }
      }
    